import {Directive, Input, TemplateRef, ViewContainerRef} from '@angular/core';
import { NonDeprecatedKeycloakService as KeycloakService } from '@core/keycloak/non-deprecated-keycloak.service';

/**
 * @whatItDoes Conditionally includes an HTML element if current user has any
 * of the authorities passed as the `expression`.
 *
 * @howToUse
 * ```
 *     <some-element *hasAnyAuthority="'ROLE_ADMIN'">...</some-element>
 *
 *     <some-element *hasAnyAuthority="['ROLE_ADMIN', 'ROLE_USER']">...</some-element>
 * ```
 */
@Directive({
  selector: '[hasAnyAuthority]'
})
export class HasAnyAuthorityDirective {

  private authorities: string[] = [];
  private roles: string[] = [];

  constructor(protected keycloakAngular: KeycloakService, private templateRef: TemplateRef<any>, private viewContainerRef: ViewContainerRef) {
  }

  @Input()
  set hasAnyAuthority(value: string | string[]) {
    this.authorities = typeof value === 'string' ? [<string>value] : <string[]>value;
    this.roles = this.keycloakAngular.getUserRoles(true);
    this.updateView();
    // Get notified each time authentication state changes.
    // TODO this.principal.getAuthenticationState().subscribe((identity) => this.updateView());
  }

  private updateView(): void {
    this.viewContainerRef.clear();
    for (const requiredRole of this.authorities) {
      if (this.roles.includes(requiredRole)) {
        this.viewContainerRef.createEmbeddedView(this.templateRef);
      }
    }
  }
}
